import { config } from '@/config';
import { LINKS } from '@/constants';
import { dateToTimeStamp } from '@/helpers';
import { apiCaller } from '@/redux/query';
import { datePickerSelector } from '@/redux/slice/Dashboard/dashboard.slice';
import { Modal, Text } from '@shopify/polaris';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  defaultOpen?: boolean;
}

const VERIFIED_THRESHOLD = 20;

const ModalReview = ({ defaultOpen = false }: IProps) => {
  const datePicker = useSelector(datePickerSelector);
  const [open, setOpen] = useState(!!defaultOpen);
  const getOverview = apiCaller.useGetOverviewQuery({
    startDate: dateToTimeStamp(datePicker.startDate).toString(),
    endDate: dateToTimeStamp(datePicker.endDate).toString(),
  });
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  const isShow = getOverview.data?.data.verified || 0 >= VERIFIED_THRESHOLD;

  const cacheKey = `age_wix_review_${config?.shop || ''}`;

  useEffect(() => {
    const isShowedReview = localStorage.getItem(cacheKey);
    if (isShowedReview === 'true') {
      return;
    }
    if (isShow) {
      timeoutIdRef.current = setTimeout(() => {
        setOpen(true);
        localStorage.setItem(cacheKey, 'true');
      }, 1000);
    }
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [cacheKey, isShow]);

  return (
    <Modal title="" titleHidden open={open} onClose={() => setOpen(false)}>
      <Modal.Section>
        <Text alignment="center" as="h3" variant="headingMd">
          Hurray! You have used Age Verification!
        </Text>
        <div className="mt-8">
          <iframe
            src={LINKS.WIX_REVIEW}
            title="Review Age Verification app iframe"
            width="100%"
            height="570px"
            style={{ border: '1px solid #E0E0E0', borderRadius: '12px' }}
          ></iframe>
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default ModalReview;
